import type { paths } from './openapi-spec'

/**
 * Query parameter names for the scan findings API endpoint.
 * Shared between api-hooks (production) and mock-findings (test/e2e).
 */
export const SCAN_FINDINGS_PARAMS = {
  analyzed: 'analyzed',
  fixStatus: 'fix-status',
  triageStatus: 'triage-status',
  triageSuggestedStatus: 'triage-suggested-status',
  patchStatus: 'include-patch-status',
  scaStatus: 'sca-status',
  fixConfidences: 'fix-confidences',
  scaClassifications: 'sca-classifications',
  severityUpdates: 'severity-updates',
  includeSeverityLabel: 'include-severity-label',
  includeSuggestedSeverityLabel: 'include-suggested-severity-label',
  minimumSeverityScore: 'minimum-severity-score',
  maximumSeverityScore: 'maximum-severity-score',
  minimumSuggestedSeverityScore: 'minimum-suggested-severity-score',
  maximumSuggestedSeverityScore: 'maximum-suggested-severity-score',
  q: 'q',
  sort: 'sort',
  order: 'order',
  embed: 'embed',
} as const satisfies Record<
  string,
  keyof NonNullable<paths['/api/v1/scans/{scan_id}/findings']['get']['parameters']['query']>
>
